module.exports = __webpack_public_path__ + "media/images/new_landing/favicon/favicon-32x32-905a90d738e2ae9f90fe9f1dd3b0d1cf.png";